import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TimerToastComponent } from './timer-toast.component';

/**
 * Tiny module that exposes the `<timer-toast>` element + its component so
 * the toast can be mounted at the layout level (default.component for the
 * browser site, desktop-shell.component for the Electron app) and receive
 * messages from anywhere via `TimerToastService`.
 *
 * Lives in its own module instead of being declared inside the bigger
 * `TimerModule` so AppModule can import just the toast without pulling
 * in FullCalendar, ECharts, and the rest of TimerModule's heavy deps.
 *
 * `TimerToastService` is `providedIn: 'root'` so it doesn't need to be
 * provided here — the component just subscribes to it on init.
 */
@NgModule({
    declarations: [TimerToastComponent],
    imports: [CommonModule],
    exports: [TimerToastComponent],
})
export class TimerToastModule {}
